import React from 'react';
import ReactDOM from 'react-dom/client';
import FormPage from './components/FormPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <FormPage />
);
